export default __webpack_public_path__ + "static/media/user.9b6b027a.svg";